import * as React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { range } from 'ramda';

import { PaginationWrapper } from '../../components/PaginationWrapper';
import { PaginationItem } from '../../components/PaginationItem';
import { getTotalCountPages } from '../../utils/pagination';
import { smoothScrollToPosition } from '../../utils/smoothScrollToPosition';
import { fetchBuildersList } from '../../actions/builders/';
import { getPagination } from '../../selectors/pagination';
import { selectLocationId } from '../../selectors/geo';
import { Dispatch } from '../../types/redux';

export const PaginationContainer = () => {
  const dispatch: Dispatch = useDispatch();
  const { page, limit, total } = useSelector(getPagination, shallowEqual);
  const locationId = useSelector(selectLocationId);
  const pagesTotal = getTotalCountPages(total, limit);

  const onSelect = React.useCallback(
    (pageSelected: number) => {
      dispatch(fetchBuildersList(limit, pageSelected, locationId));
      smoothScrollToPosition();
    },
    [dispatch, limit, locationId],
  );

  const pagesList = range(1, pagesTotal + 1);
  if (pagesTotal === 1) {
    return null;
  }

  return (
    <PaginationWrapper disabled={false}>
      {pagesList.map(pageNumber => {
        const isActive = pageNumber === page;
        const onClickHandler = isActive ? undefined : () => onSelect(pageNumber);

        return (
          <PaginationItem key={pageNumber} isActive={pageNumber === page} onClick={onClickHandler}>
            {pageNumber}
          </PaginationItem>
        );
      })}
    </PaginationWrapper>
  );
};

PaginationContainer.displayName = 'Pagination';
